import {
    blueLinks,
    robotoRegular,
    scarpaGray100,
    scarpaGray25,
    scarpaGray400,
    scarpaGray800,
    spanishViridian500,
    white,
} from '@habitech/shared';
import styled from 'styled-components';

export const Card = styled.div`
    background-color: ${white};
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(48, 49, 51, 0.08);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .header-title {
        margin: 0;
        font-family: ${robotoRegular};
        font-size: 16px;
        font-weight: 700;
        color: ${spanishViridian500};
    }
`;

export const Label = styled.label`
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 400;
    color: ${scarpaGray400};
    margin: 0;
`;

export const Trigger = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 10px 12px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${scarpaGray800};
    background-color: ${white};
    border: 1px solid ${scarpaGray100};
    border-radius: 8px;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease;

    &.placeholder {
        color: ${scarpaGray400};
    }

    &:hover {
        border-color: ${scarpaGray100};
    }

    &:focus {
        outline: none;
        border-color: ${blueLinks};
    }
`;

export const DropdownWrapper = styled.div`
    position: relative;
`;

export const DropdownList = styled.div`
    position: absolute;
    z-index: 10;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    padding: 4px;
    background-color: ${white};
    border: 1px solid ${scarpaGray100};
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(48, 49, 51, 0.12);
`;

export const Option = styled.div<{ $selected?: boolean; $disabled?: boolean }>`
    padding: 10px 12px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${({ $selected, $disabled }) => {
        if ($disabled) return scarpaGray400;
        return $selected ? white : scarpaGray800;
    }};
    background-color: ${({ $selected, $disabled }) => {
        if ($disabled) return 'transparent';
        return $selected ? blueLinks : 'transparent';
    }};
    border-radius: 6px;
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ $disabled }) => ($disabled ? 0.65 : 1)};
    transition: background-color 0.1s ease, color 0.1s ease, opacity 0.1s ease;

    &:hover {
        background-color: ${({ $selected, $disabled }) => {
            if ($disabled) return 'transparent';
            return $selected ? blueLinks : scarpaGray25;
        }};
    }
`;

export const MsiWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 4px;
`;

export const MsiCheckboxRow = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${scarpaGray800};
    cursor: pointer;

    input[type='checkbox'] {
        width: 16px;
        height: 16px;
        accent-color: ${spanishViridian500};
        cursor: pointer;
    }
`;

export const MsiSelect = styled.select`
    width: 100%;
    padding: 10px 12px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${scarpaGray800};
    background-color: ${white};
    border: 1px solid ${scarpaGray100};
    border-radius: 8px;
    cursor: pointer;
    appearance: none;
    outline: none;
    transition: border-color 0.15s ease;

    &:focus {
        border-color: ${blueLinks};
    }
`;
